import { Vessel } from '@navstation-portal/vessels/data-model/vessel';
import { VesselsVm } from './vessels-vm';
import { buildGroupedVessels } from './vessels.builder';

export function buildVesselsVm(vessels: Vessel[]): VesselsVm {
  return {
    groupedVessels: buildGroupedVessels(vessels),
  };
}
